

import Component from 'generic.basecomponent';
import $ from 'jquery';
import { TYPE_PRODUCT, TYPE_DONATION, TYPE_EVENT } from './basket-item-types';
import basketManager from './basket-manager';
import Form from '../../form/js/generic.form';
import PaymentSummary from '../../payment-summary/js/generic.payment-summary';

export default class ShopItem extends Component {
    constructor(el) {
        super(el);
        this.type = TYPE_PRODUCT;

        this.addButtonSelector = '.js-shop-item-add';
        this.quantitySelector = '.js-shop-item-quantity';
        this.optionsSelector = '.js-shop-item-option';
        this.priceSelector = '.js-shop-item-price';
        this.formSelector = '.js-shop-item-form';
        this.paymentSummarySelector = '.js-shop-item-payment-summary';
        this.participantFormSelector = '.js-shop-item-participant-form';
        this.inProgress = false;
        this.optionChangingProcessPromise = null;
        this.options = [];
        this.formInstance = null;
        this.isSuccessModalUnclosable = this.container.getAttribute('data-shop-item-success-unclosable') === 'true';
        this.init();
    }

    getEndpointUrl() {
        switch (this.type) {
            case TYPE_PRODUCT:
                return '/api/shoppingcart/AddProduct';
            case TYPE_DONATION:
                return '/api/shoppingcart/adddonation';
            case TYPE_EVENT:
                return '/api/eventregistration/addevent';
        }
    }

    init() {
        this.type = this.getItemType();
        this.itemId = this.container.getAttribute('data-shop-item-id');
        this.addButtons = this.container.querySelectorAll(this.addButtonSelector);
        this.quantityInput = this.container.querySelector(this.quantitySelector);
        this.price = this.container.querySelector(this.priceSelector);
        this.formContainer = this.container.querySelector(this.formSelector);
        this.paymentSummaryContainer = this.container.querySelector(this.paymentSummarySelector);

        const options = [...this.container.querySelectorAll(this.optionsSelector)];
        for (const i in options) {
            const option = options[i];
            const optionId = option.getAttribute('data-shop-item-option-id');
            if (optionId) {
                this.options.push({ id: optionId, element: option });
            }
            if (this.price) {
                option.addEventListener('change', this.onOptionChanged.bind(this));
            }
        }

        for (const element of this.addButtons) {
            if (element) {
                element.addEventListener('click', this.onAddButtonClick.bind(this));
            }
        }

        if (this.formContainer) {
            this.formInstance = new Form(this.formContainer, this.beforeAddToBasket.bind(this));
        }

        if (this.paymentSummaryContainer) {
            this.paymentSummaryInstance = new PaymentSummary(this.paymentSummaryContainer);
        }
    }

    getItemType() {
        const typeAttribute = this.container.getAttribute('data-shop-item-type');

        switch (typeAttribute) {
            case 'donation':
                return TYPE_DONATION;
            case 'product':
                return TYPE_PRODUCT;
            case 'event':
                return TYPE_EVENT;
            default:
                return TYPE_PRODUCT;
        }
    }

    onOptionChanged(e) {
        if (this.optionChangingProcessPromise === null) {
            this.optionChangingProcessPromise = Promise.resolve();
        }

        this.optionChangingProcessPromise = this.optionChangingProcessPromise.then(() => {
            const body = this.getRequestBody();
            basketManager.doItemPriceRequest(body).then((result) => {
                console.log(result);
                if (result.Result) {
                    this.price.innerHTML = result.Product.FormattedPrice;
                } else {
                    console.log(result.Error);
                }
            }, (error) => {
                console.log(error);
            });
        });
    }

    onAddButtonClick(e) {
        this.beforeAddToBasket(e.currentTarget);
    }

    beforeAddToBasket(currentButton) {
        if (!this.inProgress) {
            this.inProgress = true;
            this.setButtonLoadingStyle(currentButton);

            const body = this.getRequestBody(currentButton);
            this.doAddRequest(body).then((result) => {
                if (result.ValidationErrors && result.ValidationErrors.length) {
                    this.formInstance.showCustomErrors(result.ValidationErrors);
                } else {
                    basketManager.proceedSuccessAddToCart(result, { isModalUnclosable: this.isSuccessModalUnclosable });
                }
            }, (error) => {
                basketManager.proceedCartOperationError(error);
            }).then(() => {
                this.inProgress = false;
                this.removeButtonLoadingStyle(currentButton);
            });
        }
    }

    setButtonLoadingStyle(currentButton) {
        if (currentButton) {
            currentButton.classList.add('is-loading');
        }
        if (this.formInstance) {
            this.formInstance.setButtonLoadingStyle();
        }
    }

    removeButtonLoadingStyle(currentButton) {
        if (currentButton) {
            currentButton.classList.remove('is-loading');
        }
        if (this.formInstance) {
            this.formInstance.removeButtonLoadingStyle();
        }
    }

    doAddRequest(body, params = {}) {
        return new Promise((resolve, reject) => {
            $.ajax({
                method: 'post',
                url: this.getUrl(params),
                data: body
            }).done((response) => {
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }

    getUrl(params) {
        const paramsString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
        return `${this.getEndpointUrl()}` + (paramsString !== '' ? `?${paramsString}` : '');
    }

    getRequestBody(currentButton) {
        const result = {
            Id: this.itemId,
        };
        const options = this.getItemOptions();
        if (options.length) {
            result.Options = options;
        }
        if (this.type === TYPE_EVENT) {
            result.participants = this.getParticipants();
        }
        if (currentButton.parentElement.classList.contains('eproduct')) {
            result.shouldAttachAsPDF = true;
        }

        this.addQuantityToBody(result);
        return result;
    }

    getItemQuantity() {
        return this.quantityInput ? this.quantityInput.value : 1;
    }

    getItemOptions() {
        return basketManager.prepareItemOptions(this.options);
    }

    addQuantityToBody(result) {
        switch (this.type) {
            case TYPE_PRODUCT:
                result.Quantity = this.getItemQuantity();
                break;
            case TYPE_DONATION:
                result.Amount = this.getItemQuantity();
                break;
        }
    }

    getParticipants() {
        const participants = [];
        const summaryData = this.paymentSummaryInstance.data;

        summaryData.items.forEach((item) => {
            const participant = this.getParticipantData(item.id);

            if (item.products) {
                participant.products = [];
                item.products.forEach((product) => {
                    if (product.isAdded) {
                        const prod = {
                            id: product.id,
                            options: [],
                            priceInCurrentCurrency: product.cost
                        };
                        if (product.preparedOptions) {
                            prod.options = product.preparedOptions;
                        }

                        participant.products.push(prod);
                    }
                });
            }

            participants.push(participant);
        });

        return participants;
    }

    getParticipantData(id) {
        const participant = {
            id
        };

        const participantNode = this.container.querySelector(`${this.participantFormSelector}[data-participant-id="${id}"]`);

        if (participantNode) {
            const fields = [...participantNode.querySelectorAll('input:not([type=button]), select, textarea')];
            fields.forEach((field) => {
                const name = field.name;
                if (name) {
                    switch (field.type) {
                        case 'checkbox':

                        {
                            if (typeof participant[name] === 'undefined') {
                                participant[name] = [];
                            }
                            if (field.checked) {
                                participant[name].push(field.value);
                            }

                            break;
                        }
                        case 'radio':
                        {
                            if (typeof participant[name] === 'undefined') {
                                participant[name] = '';
                            }
                            if (field.checked) {
                                participant[name] = field.value;
                            }

                            break;
                        }
                        case 'select-multiple':
                        {
                            participant[name] = [...field.options].filter(option => option.selected)
                                .map(option => option.value);
                            break;
                        }
                        default:
                            participant[name] = field.value;
                    }

                    if (typeof participant[name] === 'object' && participant[name].length === 0) {
                    // jquery ajaz doesn's send empty arrays
                        participant[name] = [''];
                    }
                }
            });
        }

        return participant;
    }
}

ShopItem.id = 0;



// WEBPACK FOOTER //
// ./app/components/shop/js/generic.shop-item.js